module.exports = __webpack_public_path__ + "img/i_bookmark_s.8089cadf.svg";